import { PaginatedModel } from './../../shared/component/select/pagination/model/paginated.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PartnerCreation } from './model/parter-creation.model';
import { PartnerModel } from './model/partner.model';
import { UpdatePartner } from './model/update-parter.model';
import { PartnerDefaultRuleModel } from './model/partner-default-rule.model';

@Injectable({
    providedIn: 'root'
})
export class PartnerService {
    BASE = environment.PARTNER;

    constructor(protected httpService: HttpClient) { }

    private buildQueryParams(searchTerm: string | undefined, limit: number, page: number, ids: string[], status?: 'ACTIVE' | 'INACTIVE'): HttpParams {
        let queryParams = new HttpParams()
            .set('limit', limit)
            .set('page', page);

        if (searchTerm) {
            queryParams = queryParams.set('searchTerm', searchTerm);
        }

        if (status) {
            queryParams = queryParams.set('status', status)
        }

        ids.forEach((id) => queryParams = queryParams.append('ids[]', id));

        return queryParams;
    }
    public createPartner(partner: PartnerCreation): Observable<PartnerModel> {
        return this.httpService.post<PartnerModel>(`${this.BASE}/partner`, partner);
    }
    public updatePartner(partnerId: string, payload: UpdatePartner): Observable<void> {
        return this.httpService.patch<void>(`${this.BASE}/partner/${partnerId}`, payload);
    }
    public deletePartner(partnerId: string): Observable<void> {
        return this.httpService.delete<void>(`${this.BASE}/partner/${partnerId}`);
    }
    public getPartner(partnerId: string): Observable<PartnerModel> {
        return this.httpService.get<PartnerModel>(`${this.BASE}/partner/${partnerId}`);
    }
    public findByDefaultRule(defaultRule: PartnerDefaultRuleModel): Observable<PartnerModel | null> {
        return this.httpService.post<PartnerModel | null>(`${this.BASE}/partner/default-rules/find`, defaultRule);
    }
    public getPartners(searchTerm?: string, page = 1, limit = 10, ids: string[] = [], status?: 'ACTIVE' | 'INACTIVE'): Observable<PaginatedModel<PartnerModel>> {
        const params = this.buildQueryParams(searchTerm, limit, page, ids, status);
        return this.httpService.get<PaginatedModel<PartnerModel>>(`${this.BASE}/partner`, { params });
    }
}
